var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.rows),function(r){return _c('div',{key:r,staticClass:"row"},_vm._l((_vm.rowColMap[r]),function(c){return _c('div',{key:c,class:'text-center ml-3 mt-4 '+_vm.makeWidth(r, c)},[_c('crossfilterdc',{attrs:{"crossfilterdc":_vm.vizDataRowCol[r][c][0]}})],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }